import { Profile } from "@happy-legal/graphql-types";
import { createContext, ReactNode } from "react";
import { MUTATION_UPDATE_PROFILE } from "../gql/mutations";
import { profileReducer, TProfileAction, TProfileState } from "../reducer";
import { createProvider, IObjectContextType } from "./ProviderFactory";

export type TProfileContext = IObjectContextType<TProfileState, TProfileAction>;
export const ProfileContext = createContext<TProfileContext>(undefined!);
// TODO: https://www.rivoltafilippo.com/typing-react-context-to-avoid-an-undefined-default-value

ProfileContext.displayName = "Profile Context";

export const profileInitState = {
  profile: {} as Profile,
  allProfiles: { items: [], total: 0 },
};

const ProfileProvider = ({ children }: { children: ReactNode }) =>
  createProvider(
    ProfileContext,
    profileReducer,
    profileInitState,
    children,
    MUTATION_UPDATE_PROFILE
  );

export default ProfileProvider;
